import * as z from "zod"
import { AircraftType } from "@prisma/client"

export const AircraftModel = z.object({
  id: z.string(),
  created_at: z.date(),
  updated_at: z.date(),
  name: z.string(),
  type: z.nativeEnum(AircraftType).nullish(),
})
